module.exports = __webpack_public_path__ + "img/239w.ad15f71.jpg";